import Divider from "@mui/material/Divider";
import { type FC } from "react";
import { NavLink } from "react-router";

import { BlurContainer } from "~/components/UI/BlurContainer";
import { ROUTES } from "~/constants/routing";
import { renderBadge } from "~/feature/categories/components/Categories/utils";
import { MoreCategoriesButton } from "~/feature/categories/components/MoreCategoriesButton";
import { MoreTagsButton } from "~/feature/categories/components/MoreTagsButton";
import { type CategoryTab } from "~/feature/categories/hooks/useCategoryTabs";
import { type ICategory } from "~/types/category";

import * as Styled from "./Categories.styles";

export interface ICategoriesProps {
  categories: ICategory[];
  slug?: string | null;
  categoryTabs: CategoryTab[];
}

export const Categories: FC<ICategoriesProps> = ({
  categories,
  slug,
  categoryTabs,
}) => {
  const getIsActive = (id: string) => id === slug;

  const displayCategoryTabs = categoryTabs.slice(0, 5);
  const additionalCategoryTabs = categoryTabs.slice(5);
  const displayCategories = categories.slice(0, 10);
  const additionalCategories = categories.slice(10);
  const isMoreButton = !!additionalCategories?.length;

  return (
    <Styled.Root>
      <BlurContainer>
        <Styled.Container>
          {displayCategoryTabs.map((tab) => (
            <Styled.CategoryWrapper key={tab.key}>
              <Styled.CategoryButton
                component={NavLink}
                to={tab.to}
                $isActive={tab.isActive}
              >
                <Styled.CategoryText variant="caption" $isActive={tab.isActive}>
                  {tab.label}
                </Styled.CategoryText>
                {renderBadge(tab.key)}
              </Styled.CategoryButton>
            </Styled.CategoryWrapper>
          ))}
          {additionalCategoryTabs.length > 0 && (
            <MoreTagsButton categoryTabs={additionalCategoryTabs} />
          )}
          <Divider orientation="vertical" flexItem />
          {displayCategories.map((category) => (
            <Styled.CategoryWrapper key={category.id}>
              <Styled.CategoryButton
                component={NavLink}
                to={ROUTES.category.createURL(category.slug)}
                $isActive={getIsActive(category.slug)}
              >
                <Styled.CategoryText
                  variant="caption"
                  $isActive={getIsActive(category.slug)}
                >
                  {category.name}
                </Styled.CategoryText>
              </Styled.CategoryButton>
            </Styled.CategoryWrapper>
          ))}
          {isMoreButton && (
            <MoreCategoriesButton
              categories={additionalCategories}
              getIsActive={getIsActive}
            />
          )}
        </Styled.Container>
      </BlurContainer>
    </Styled.Root>
  );
};
